import { useEffect, useState } from "react";
import { useFetchGetData } from "./useFetchData";
import { useQueryParams } from "./useLocationData";
import globalMapping from "../data/mapping/components/globalMapping";
import globalMockData from "../data/components/global-data.json";
import { useLanguage } from "./useLanguage";

const useGlobalData = () => {
  const queryKey = "globalData";

  let language = useLanguage();
  const queryParams = useQueryParams();

  const queryPath = "/jsonapi/block_content?filter[field_json_component]=3";

  const isMockData = queryParams.get("useMockData") === "true";

  const [globalData, setGlobalData] = useState("");

  const { isLoading, error, data, refetch } = useFetchGetData(
    queryKey,
    queryPath,
    isMockData
  );

  useEffect(() => {
    if (data && !isMockData) {
      const mappedData = globalMapping(data);
      setGlobalData(mappedData);
    }
  }, [data, isMockData]);

  useEffect(() => {
    refetch()
  }, [ language, refetch ]);

  if (isMockData) {
    return { error: false, isLoading: false, globalData: globalMockData };
  }

  return { error, isLoading, globalData };
};

export default useGlobalData;
